import CognitoUserEdit from './abstract/CognitoUserEdit'
import AWSAPI from '../../../common/AWSAPI'
import Config from '../../../Config'

class CompanyUserEdit extends CognitoUserEdit {
  constructor (props) {
    super(props)
    const initialState = this.getInitialState()
    this.state = initialState
    this.nameTitle = 'ユーザ名'
    this.apiUrl = Config.companyAdminApiUrl.companyUser
    this.userRoleName = 'ユーザ'
    this.userRoleUrl = 'company_user'
    this.userRole = 'companyUser'
  }
  componentWillMount () {
    const {params} = this.props.match
    const id = params.id
    if (id) {
      this.loadUserDetail(id)
    } else {
      const initialState = this.getInitialState()
      initialState.isLoaded = true
      this.setState(initialState)
      const parentID = AWSAPI.getCurrentUserId('companyAdmin')
      this.setState({
        parentID: parentID
      })
    }
  }
}

export default CompanyUserEdit



// WEBPACK FOOTER //
// ./src/company_admin/pages/secure/CompanyUserEdit.js